import { render, staticRenderFns } from "./VanIcon.vue?vue&type=template&id=60167470&"
import script from "./VanIcon.vue?vue&type=script&lang=js&"
export * from "./VanIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports